import {set, toggle} from '@/utils/vuex'

export default {
  setDrawer: set('drawer'),
  setImage: set('image'),
  setColor: set('color'),
  toggleDrawer: toggle('drawer'),
  SHOW_NOTIFICATION(state, notification) {
    for (const config in notification) {
      if (state.notification.hasOwnProperty(config)) {
        state.notification[config] = notification[config]
      }
      if (notification['color'] === undefined) {
        state.notification['color'] = 'error'
      }
    }
    // handling multiple-line messages
    if (typeof notification.body === 'object') {
      state.notification.body = ''
      state.notification.multiline = true
      for (const field in notification.body) state.notification.body += `${field}: ${notification.body[field]} `
    }
    state.notification.show = true
  },
  HIDE_NOTIFICATION(state) {
    state.notification.show = false
    state.notification.multiline = false
  },
  START_LOADING(state) {
    state.loading = true
  },

  STOP_LOADING(state) {
    state.loading = false
  },
}
